import React, { useEffect, useState } from 'react';
import { getSucursalImage } from '../../utils/sucursalImage';
import { useProtectedFileUrl } from '../../hooks/useProtectedFileUrl';
import './SucursalLogo.css';

// Logo cuadrado de la sucursal (object-fit: contain). Sin logo o si la imagen falla → ícono genérico.
export default function SucursalLogo({ sucursal, size = 40, className = '', decorative = false }) {
  const src = getSucursalImage(sucursal);
  const protegido = useProtectedFileUrl(src);
  const [failed, setFailed] = useState(false);
  useEffect(() => setFailed(false), [src]);
  const name = sucursal?.nombre || 'Sucursal';
  const label = decorative ? undefined : `Logo de ${name}`;
  return (
    <span className={`sucursal-logo ${className}`} style={{ '--logo-size': `${size}px` }}
      role={decorative ? undefined : 'img'} aria-label={label} aria-hidden={decorative || undefined}>
      {protegido.url && !failed
        ? <img src={protegido.url} alt="" onError={() => setFailed(true)} />
        : <i className="bx bx-store-alt" aria-hidden="true" />}
    </span>
  );
}
